// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"f544cc12","137":"9c712c14","156":"571cd626","223":"cf0fa72b","320":"1cca9456","407":"276a5dbd","519":"b32445e1","524":"ab442da8","589":"11e7fde0","613":"973e76fd","618":"ce706aa7","664":"2a0938ff","762":"f565f180","841":"e173be9c","845":"f32afad5","992":"a69f9e85"}[chunkId] + ".chunk.js";
};